

























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Mixins, Vue } from 'vue-property-decorator';
import { StringHelper } from '@fruitpackage/helpers';
import { kebabCase } from 'lodash';
import { ApplyMixin, PopupMixin } from '@mixin';
import PageMain from '@part/layout/PageMain.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            next: null,
            autosave: null,
            viewDisabled: false,
            saveClicked: false,
        };
    },

    components: {
        PageMain,
    },

    mixins: [
        ApplyMixin,
        PopupMixin,
    ],

    computed: {
        viewClass() {
            return (this.viewDisabled) ? 'view-apply__view is-disabled' : 'view-apply__view';
        }
    },

    created() {
        this.$root.$on('root::step::autosave', (autosave) => {
            this.autosave = autosave;
        });

        this.$root.$on('root::step::nextClick', this.nextClick);

        this.$root.$on('root::step::next', (next) => {
            this.setNext(next);
        });
    },

    mounted() {
        this.$root.$emit('root::layout::showApplyProgress', true);
        this.$root.$emit('root::layout::hideFooter', true);
    },

    beforeDestroy() {
        this.$root.$emit('root::layout::showApplyProgress', false);
        this.$root.$emit('root::layout::hideFooter', false);
    },

    destroyed() {
        this.$root.$off('root::step::next');
        this.$root.$off('root::step::nextClick');
        this.$root.$off('root::step::autosave');
    },

    methods: {
        setNext(next) {
            this.next = next;

            if (!next) return;
            if (next.to) return;

            next.to = this.getPrevNextStep(this.groupKey, this.stepKeys, this.stepIndex, true);

            if (next.to) return;

            const nextGroupKey = this.groupKeys[this.groupIndex + 1];
            if (nextGroupKey) {
                const nextGroup = this.groups[nextGroupKey];
                const nextStepKeys = Object.keys(nextGroup.steps);
                const nextStepIndex = -1;

                next.to = this.getPrevNextStep(nextGroupKey, nextStepKeys, nextStepIndex, true);
            }
        },

        nextClick() {
            if (this.next.onNext) {
                this.next.disabled = true;
                this.next.onNext().then(response => {
                    if (this.next)
                        this.next.disabled = false;

                    if (typeof response === 'boolean' && response)
                        this.$router.push(this.next.to);

                    else if (response)
                        this.$router.push(response);
                });
            } else {
                this.$router.push(this.next.to);
            }
        },

        saveClick() {
            this.saveClicked = true;

            if (this.next.onNext) {
                this.next.disabled = true;
                this.next.onNext().then(response => {
                    this.$router.push('/projects');
                });
            } else {
                this.$router.push('/projects');
            }
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Apply extends Vue {}

